var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showMenu)?_c('navbar',{attrs:{"language":_vm.language,"loggedIn":_vm.loggedIn}}):_vm._e(),_vm._v(" "),_c('router-view',{attrs:{"language":_vm.language}}),_vm._v(" "),(_vm.showMenu)?_c('sectionFooter',{attrs:{"language":_vm.language}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c55f8dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 